import styled from "styled-components";

export const Bar = styled.div`
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  background: #1a1a1a;
  color: #fff;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  z-index: 150;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.12);
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-size: 12px;
  color: #fff;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  color: #f9d293;
  margin-top: 4px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CompareBtn = styled.button<{ $disabled?: boolean }>`
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 12px;
  font-weight: 900;
  background: ${(p) => (p.$disabled ? "#555" : "#008cff")};
  color: #fff;
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
`;

export const CloseBtn = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #333;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
`;
